import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateInspectionJobMutationVariables = Types.Exact<{
  input: Types.StartInspectionJobInput;
}>;


export type CreateInspectionJobMutation = { __typename?: 'mutation_root', start_inspection_job?: { __typename?: 'StartInspectionJobOutput', success: boolean, job_id?: any | null, organization_id?: string | null, user_invitation_id?: string | null, property_id?: string | null, error?: string | null, inspection_job?: { __typename?: 'inspection_jobs', id: any, property_id: any, organization_id: any, workspace_id: any, created_by_user_id: string, inspection_type: string, jurisdiction?: string | null, jurisdiction_id?: any | null, state: string, iris_score?: number | null, estimated_onsite_minutes?: number | null, requested_inspection_date?: any | null, property_context?: any | null, checklist_generated_at?: any | null, analysis_started_at?: any | null, analysis_completed_at?: any | null, error_message?: string | null, error_step?: string | null, report_json?: any | null, created_at?: any | null, updated_at?: any | null, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, county?: string | null, city?: string | null, ahj_type: string, primary_codes?: any | null, website_url?: string | null, notes?: string | null, active: boolean, created_at: any, updated_at: any } | null, inspection_checklist_items: Array<{ __typename?: 'inspection_checklist_items', id: any, sort_order: number, category: string, doctrine_item_key: string, item_name: string, capture_instructions?: string | null, example_image_url?: string | null, required: boolean, doctrine_checklist_item_ref?: string | null, created_at: any, applicable_codes?: any | null, evaluation_criteria?: string | null }> } | null, organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, user_invitation?: { __typename?: 'user_invitations', id: any, email: string, role?: string | null, status: string, message?: string | null, properties_ids?: Array<string> | null, organization_id?: any | null, sender_id?: string | null, handover_id?: any | null, sender?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, organization_id: any } | null } | null };


export const CreateInspectionJobDocument = gql`
    mutation createInspectionJob($input: StartInspectionJobInput!) {
  start_inspection_job(input: $input) {
    success
    job_id
    inspection_job {
      id
      property_id
      organization_id
      workspace_id
      created_by_user_id
      inspection_type
      jurisdiction
      jurisdiction_id
      jurisdiction_record {
        id
        name
        short_name
        state
        county
        city
        ahj_type
        primary_codes
        website_url
        notes
        active
        created_at
        updated_at
      }
      state
      iris_score
      estimated_onsite_minutes
      requested_inspection_date
      property_context
      checklist_generated_at
      analysis_started_at
      analysis_completed_at
      error_message
      error_step
      report_json
      created_at
      updated_at
      inspection_checklist_items {
        id
        sort_order
        category
        doctrine_item_key
        item_name
        capture_instructions
        example_image_url
        required
        doctrine_checklist_item_ref
        created_at
        applicable_codes
        evaluation_criteria
      }
    }
    organization_id
    organization {
      id
      name
      email
      type
      organizationImageURL
    }
    user_invitation_id
    user_invitation {
      id
      email
      role
      status
      message
      properties_ids
      organization_id
      sender_id
      sender {
        id
        first_name
        last_name
        role
        email
        organization_id
      }
      handover_id
    }
    property_id
    property {
      id
      name
      address
      organization_id
    }
    error
  }
}
    `;
export type CreateInspectionJobMutationFn = Apollo.MutationFunction<CreateInspectionJobMutation, CreateInspectionJobMutationVariables>;

/**
 * __useCreateInspectionJobMutation__
 *
 * To run a mutation, you first call `useCreateInspectionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionJobMutation, { data, loading, error }] = useCreateInspectionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInspectionJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateInspectionJobMutation, CreateInspectionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInspectionJobMutation, CreateInspectionJobMutationVariables>(CreateInspectionJobDocument, options);
      }
export type CreateInspectionJobMutationHookResult = ReturnType<typeof useCreateInspectionJobMutation>;
export type CreateInspectionJobMutationResult = Apollo.MutationResult<CreateInspectionJobMutation>;
export type CreateInspectionJobMutationOptions = Apollo.BaseMutationOptions<CreateInspectionJobMutation, CreateInspectionJobMutationVariables>;